import {useStorageStore} from "~/store/storage";
import {useContentStore} from "~/store/content";
import { useMyDbStore } from "~/store/mydb";
import { useSubscriptionStore } from "~/store/subscriptions";


export default defineNuxtPlugin(nuxtApp => {
    return {
        provide: {
            storage: useStorageStore(),
            content: useContentStore(),
            mydb: useMyDbStore(),
            subscriptionStore: useSubscriptionStore(),
        }
    }
});
